import { PORTAL_CLASS_NAME } from '@billy/design-system'
import React, { ReactElement } from 'react'
import ReactDOM from 'react-dom'
import { ToastContainer as ToastifyContainer } from 'react-toastify'

export const ToastContainer = (): ReactElement => {
  return ReactDOM.createPortal(<ToastifyContainer className={PORTAL_CLASS_NAME} />, document.body)
}
